
import { feedbackDetails } from '@/interfaces/feedback';
import { MutationTree } from 'vuex';


const mutation: MutationTree<feedbackDetails> = {

    setEnvios(state, envios) {
        state.envios = envios;
    },
    setFicheros(state, ficheros) {
        state.ficheros = ficheros;
    },
    setId(state, id) {
        state.id = id;
    },
    setNombre(state, nombre) {
        state.nombre = nombre;
    }
    
}


export default mutation;